import { Form } from 'antd';
import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  width: 100%;
`;

export const FormItemHalf = styled(Form.Item)`
  flex: 1;
  min-width: 250px;
`;

export const MobileFormItemFull = styled(Form.Item)`
  width: 100%;
`;
